<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>Mo Quality Assessment Report</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-2">
        <label for=""><span class="text-danger">* </span><u>Filter by From</u></label>
        <input type="date" [(ngModel)]="filterable.from" class="form-control" placeholder="From">
      </div>
      <div class="col-2">
        <label for=""><span class="text-danger">* </span><u>Filter by To</u></label>
        <input type="date" [(ngModel)]="filterable.to" class="form-control" placeholder="To">
      </div>
      <div class="col-2">
        <label for="gotoShortCode"><u>Goto ShortCode</u></label>
        <ng-select [items]="allShortCodes" bindLabel="scView" placeholder="Goto ShortCode" [(ngModel)]="targetShortCode" class="form-control" (ngModelChange)="gotoTargetShortCode($event)">
        </ng-select>
      </div>
      <div class="col-2">
        <label for=""><span class="text-danger">* </span><u>Filter by Source</u></label>
        <select [(ngModel)]="filterable.source" class="form-control" placeholder="Source" (ngModelChange)="changeSource($event)">
          <option *ngFor="let source of sourceList" [ngValue]="source">{{source.name}}</option>
        </select>
      </div>
      <div class="col-2">
        <label for=""><span class="text-danger">* </span><u>Filter by Country</u></label>
        <select [(ngModel)]="filterable.country" class="form-control" placeholder="Country" (ngModelChange)="changeCountry($event)">
          <option *ngFor="let country of countryList | keyvalue" [ngValue]="country.value">{{country.key}}</option>
        </select>
      </div>
      <div class="col-2">
        <label for=""><span class="text-danger">* </span><u>Filter by Operator</u></label>
        <select [(ngModel)]="filterable.operator" class="form-control" placeholder="Operator" (ngModelChange)="changeOperator($event)">
          <option *ngFor="let op of operatorList | keyvalue" [ngValue]="op.key" >{{op.key}}</option>
        </select>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-2">
        <label for=""><span class="text-danger">* </span><u>Filter by Short Code</u></label>
        <!-- <input type="text" formControlName="shortCode" class="form-control" placeholder="enter short code" /> -->
        <ng-select [items]="shortCodeList" (clear)="onClear()" placeholder="Select short code" [(ngModel)]="filterable.shortCode" class="form-control" (ngModelChange)="changeShortCode($event)">
        </ng-select>
      </div>
      <div class="col-2">
        <label for=""><span class="text-danger">* </span><u>Filter by Keyword</u></label>
        <select [(ngModel)]="filterable.keyword" class="form-control" placeholder="Keyword" (ngModelChange)="changeKeyword($event)">
          <option *ngFor="let kw of keywordList" [ngValue]="kw">{{kw.keyword}}</option>
        </select>
      </div>
      <div class="col-2" *ngIf="affiliateList != null && affiliateList.length > 0">
        <label for=""><span class="text-danger">* </span><u>Filter by Affiliate</u><i class="fas" placement="right" ngbTooltip="'NULL': affiliate is null before affiliate is enabled">'NULL'</i>
          &nbsp;<i class="fas" placement="right" ngbTooltip="'-': it's default value when affiliate is null after affiliate is enabled">'-'</i>
        </label>
        <select [(ngModel)]="filterable.affiliate" class="form-control" placeholder="Affiliate" >
          <option *ngFor="let af of affiliateList" [ngValue]="af">{{af}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Days</u></label>
        <input numeric type="text" [(ngModel)]="filterable.days" class="form-control" placeholder="enter days">
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Exchange Rate</u></label>
        <input numeric decimals="5" type="text" [(ngModel)]="filterable.exchangeRate" class="form-control" placeholder="enter exchange rate">
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Gateway Rate</u></label>
        <input numeric decimals="5" type="text" [(ngModel)]="filterable.gatewayRate" class="form-control" placeholder="enter gateway rate">
      </div>
      <div class="col">
        <label for=""><u>Data Flag</u></label>
        <select [(ngModel)]="filterable.realtime" class="form-control" placeholder="realtime">
          <option *ngFor="let rtf of realtimeFlags | keyvalue" [ngValue]="rtf.value">{{rtf.key}}</option>
        </select>
      </div>
    </div>
  </div>
</div>
<div class="mt-3 mb-2 row">
  <div class="col-2 align-self-center">
    Total Results: {{totalItems}}<span  *ngIf="resultName != ''"  > - <span class="font-weight-bold font-italic text-danger">{{resultName}}</span> </span>
  </div>
  <div class="col-2 align-self-end text-right ml-auto">
    <button class="btn btn-primary btn-sm mr-2" (click)="search()">Search</button>
    <button class="btn btn-success btn-sm mr-2" (click)="export()" *ngIf="!exporting">Export</button>
    <button class="btn btn-success btn-sm mr-2 d-none" id="download" (click)="openModal(viewDownloadUrl)">Open</button>
    <button class="btn btn-success btn-sm mr-2" *ngIf="exporting" disabled>Exporting</button>
  </div>
  <!-- <div class="col-2 align-self-center" *ngIf="maxPageSize > 1">
    <label for=""><u>Go to page </u> <span class="small">(Max: {{maxPageSize}})</span></label>
    <input type="number" class="form-control form-control-sm" placeholder="Page" [(ngModel)]="goToPage" max="{{maxPageSize}}">
  </div>
  <div class="col-2 align-self-center" *ngIf="maxPageSize > 1">
    <button (click)="setPage(goToPage)" class="btn btn-sm btn-outline-primary">Go</button>
  </div> -->
</div>

<ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs mt-4">
  <li *ngFor="let report of qaReports | keyvalue; index as i" [ngbNavItem]="i">
    <a ngbNavLink>
      <h5>{{report.key}} ({{report.value?.length - 1}})</h5>
    </a>
    <ng-template ngbNavContent>
      <div class=" table-responsive">
        <table id="retList" class="table table-striped table-bordered mt-3" style="width:100%">
          <thead>
            <tr class="text-center">
              <th>Day</th>
              <th>ShortCode</th>
              <th>Keyword</th>
              <th>Affiliate</th>
              <th>Operator</th>
              <th>Total MO</th>
              <th>Cost Per MO</th>
              <th>Currency Exchange</th>
              <th>Total Cost</th>
              <th>Total Revenue</th>
              <th>Gateway Revenue</th>
              <th>ROI</th>
              <th>Total Days</th>
              <th>Avg Daily Increase</th>
              <th>Avg Daily Revnue</th>
              <th>Total Months Reach Roi</th>
              <th>Total Profit</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let qa of report.value; index as i" class="text-right">
              <td class="text-center">{{qa.day}}</td>
              <td class="text-center">{{qa.shortCode}}</td>
              <td class="text-center">{{qa.keyword}}</td>
              <td class="text-center">{{qa.affiliate}}</td>
              <td class="text-center">{{qa.operator}}</td>
              <td>{{qa.moNum}}</td>
              <td>{{qa.costPerMo}}</td>
              <td>{{qa.currencyRate}}</td>
              <td>{{qa.totalCost}}</td>
              <td>{{qa.totalRevenue}}</td>
              <td>{{qa.gatewayRevenue}}</td>
              <td>{{qa.roi}}</td>
              <td *ngIf="qa.days != 0">{{qa.days}}</td>
              <td *ngIf="qa.days == 0"></td>
              <td>{{qa.avgDailyIncrease}}</td>
              <td>{{qa.avgDailyRevenue}}</td>
              <td>{{qa.totalMonthRoi}}</td>
              <td>{{qa.totalProfit}}</td>
            </tr>
          </tbody>
          <tfoot>
          </tfoot>
        </table>
      </div>
    </ng-template>
  </li>
</ul>
<div [ngbNavOutlet]="nav" class="mt-2 mb-4"></div>

<ng-template #viewDownloadUrl let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="downloadUrl-header">Download URL</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group row">
      <div class="col-12">
        Click to download:
        <a href={{downloadUrl}} target="_blank">
          {{downloadUrl}}
        </a>
      </div>
    </div>
  </div>
</ng-template>
